import { render, staticRenderFns } from "./EchartScatter.vue?vue&type=template&id=8ed5c0f8&"
import script from "./EchartScatter.vue?vue&type=script&lang=js&"
export * from "./EchartScatter.vue?vue&type=script&lang=js&"
import style0 from "./EchartScatter.vue?vue&type=style&index=0&id=8ed5c0f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports